// extracted by mini-css-extract-plugin
export default {"form_container":"NewUser_form_container__-iQJ9","card_container":"NewUser_card_container__PQrr4","input_container":"NewUser_input_container__wdxrm"};